import { makeStyles, useTheme } from "@material-ui/core/styles"
export const useFacetUIStyles = makeStyles({
  cardSadhow: {
    boxShadow: "0px -1px 0px 0px rgba(0, 0, 0, 0.12) inset",
  },
})

export const useFacetUIContentStyles = makeStyles({
  dividerBottom: {
    borderBottom: "0.1em solid rgba(0, 0, 0, 0.1)",
  },

  listProperty: {
    display: "flex",
    maxHeight: 400,
    overflowY: "scroll",
  },
  listItem: {
    alignItems: "center",
  },
  verticalDivider: {
    flex: 1,
  },

  textFiled1: {
    width: "280px",
    marginRight: "32px",
  },
  textFiled2: {
    width: "250px",
    marginRight: "20px",
  },
})
